import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import Accordion from '../../../atoms/accordion/Accordion';
import { cnMerge } from '../../../../utils/utils';

export const CollapseItem = ({
  title,
  text,
  darkMode = true,
  iconColor,
  className,
}) => {
  return (
    <Accordion
      title={title}
      darkMode={darkMode}
      iconColor={iconColor}
      className={cnMerge(className, 'border-primary-500')}
    >
      <Typography
        as="span"
        textAlign={'left'}
        fontVariant="md"
        className={`${darkMode && '!text-primary-50'} opacity-75`}
      >
        {text}
      </Typography>
    </Accordion>
  );
};
